<template>
<div class="conNav">
    <ul>
        <li v-for="(item) in dataList" :key="item.id" >
            <router-link :to="{name:item.pathName}">
                <span :class="{'active':item.pathName===tabSelect}">{{item.name}}</span>
            </router-link>
        </li>

    </ul>
</div>
</template>

<script>
export default {
    name: "comNav",
    data(){
        return{
            dataList:[
                {id:'1',name:"首页",pathName:'comHome'},
                {id:'2',name:"拍品中心",pathName:'comItem'},
                {id:'3',name:"拍卖预展",pathName:'comPreviews'},
                {id:'4',name:"拍卖结果",pathName:'comResults'},
                {id:'5',name:"征集送拍",pathName:'comCollect'},
                {id:'6',name:"新闻",pathName:'comNewsVideo'},
                {id:'7',name:"关于我们",pathName:'comAbout'},
            ],
            tabSelect:'comHome'
        }
    },
    mounted() {
        this.tabSelect = this.$router.history.current.name
    },
    methods:{
        tabClick(index){
            this.tabSelect=this.dataList[index].id;
            this.$emit('tabNavClick',this.tabSelect,this.dataList[index])
        }
    }
}
</script>

<style scoped lang="scss">
.conNav{
    ul{
        display: flex;
        justify-content: space-around;
        li{
            cursor: pointer;
            height: 29px;
            background: url(../../../assets/imgs/old/navBgCom.png) no-repeat right center;
            span{
                display: block;
                font-family: "微软雅黑";
                font-size: 14px;
                color: #333;
                padding: 5px 45px 0 45px;
                &:hover,&.active{
                    border-top: 3px solid #000;
                    padding-top: 2px;
                }
            }

            &:nth-child(7){
                background: none;
            }
        }
    }
}
</style>